<script>
  import { get } from "svelte/store";
  import { onMount, onDestroy } from "svelte";

  import {
    am_selected_adaptations,
    am_sideBySideComparisonStore,
  } from "./stores_adaptation_measures.js";

  // Incoming variables
  export let viewAdaptationOption;

  console.log("viewAdaptationOption", viewAdaptationOption);

  // Holds the state if the multi-select is disabled
  let isDisabled;

  // Holds state if multi-select
  let optionChecked;

  // Lifecycle methods
  onMount(async () => {
    console.log("on destroy");
    isDisabled = false;
    optionChecked = false;
  });

  // Reactive functions

  // React to the am_selected_adaptations store changes to disable this component's
  // checkbox if multi-select and more than two options have been checked,
  // or renable if < 2 boxes are checked
  $: {
    const old = $am_selected_adaptations;
    console.log("reacting to state: " + viewAdaptationOption.toggleValue);
    let count = old.reduce((accumulator, value) => {
      return accumulator + (!!value ? 1 : 0);
    }, 0);

    // Enable is 0 or 1 options are checked.
    if (count < 2) {
      console.log("count < 2, enabling");
      isDisabled = false;
    }

    // If 2 options are checked, only disable if this is a previously unchecked item
    // leaving the checked ones enabled to allow the user to deselect.
    else if (!!!optionChecked && count >= 2) {
      isDisabled = true;
      console.log("count > 2, enabling");
    } else {
      isDisabled = false;
      console.log("count < 2, aaa enabling");
    }
  }

  // In multi-select (compare mode), when a user clicks on a checkbox, update the specified box (set to true or false as necessary)
  $: {
    const old = get(am_selected_adaptations);
    old[viewAdaptationOption.toggleValue] = !!optionChecked;
    am_selected_adaptations.set(old);
    console.log(
      viewAdaptationOption.toggleValue + " am_selected_adaptations is now: ",
      get(am_selected_adaptations)
    );
    // The component that sets the state won't react to the store change, update my disabled now
    let count = old.reduce((accumulator, value) => {
      return accumulator + (!!value ? 1 : 0);
    }, 0);

    // Enable is 0 or 1 options are checked.
    if (count < 2) {
      isDisabled = false;
    }
  }
  const slugify = (str = "") =>
    str.toLowerCase().replace(/ /g, "-").replace(/\./g, "");
</script>

<span>
  <span class="rowzz">
  <span class="pr-5">
    <input type="checkbox" bind:checked={optionChecked} disabled={isDisabled} />
    </span>
    <span class="colzz">
      <label class="view-button" for={slugify(viewAdaptationOption.buttonName)}>
      {viewAdaptationOption.buttonName}
    </label>
    </span>
  </span>
  

  <!-- checkbox subtitle popup  -->
  <div
    class="radio-subtitle-popups"
    id="adaptation-measures-widget-container" 
    for={slugify(viewAdaptationOption.buttonName)}
  >
    <calcite-popover class="subtitle-popup" heading={viewAdaptationOption.buttonName} reference-element={viewAdaptationOption.buttonName} closable>
      <div style="margin: 0px" class="radio-subtitle-text-container">
        <div class="adaptation-choice-subtitle">{viewAdaptationOption.subtitle}</div>
      </div>
    </calcite-popover>
    <div class="radio-info-icon-container">
      <calcite-icon class="radio-info-icon" id={viewAdaptationOption.buttonName} icon="information"></calcite-icon>
    </div>
  </div>

  <div class="adaptation-choice-subtitle subtitle-big-screen">{viewAdaptationOption.subtitle}</div>
  
  <!-- <div class="adaptation-choice-subtitle">{viewAdaptationOption.subtitle}</div> -->
</span>

<style>
</style>
